<template>
  <van-pull-refresh
    v-model="refreshing"
    @refresh="onRefresh"
    :pulling-text="pullingText"
    :loosing-text="loosingText"
    :success-text="successText"
    :loading-text="loadingText"
  >
    <slot> </slot>
  </van-pull-refresh>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    pullingText:{
      type: String,
      default: "Pull down to refresh",
    },
    loosingText: {
      type: String,
      default: "Release to refresh",
    },
    successText: {
      type: String,
      default: "Refresh successful",
    },
    loadingText: {
      type: String,
      default: "Loading...",
    },
  },
  watch: {
    value() {
      this.refreshing = this.value;
    },
  },
  data() {
    return {
      refreshing: this.value,
    };
  },
  methods: {
    onRefresh() {
      this.$emit("refresh");
    },
  },
};
</script>
<style lang="scss" scoped></style>
